var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiStepTestRun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 21.5L21.5714 17L16.9276 14.0448C16.2924 15.0529 15.4662 15.9287 14.5 16.6214V21.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 12.5V16.6214C15.4662 15.9287 16.2924 15.0529 16.9276 14.0448L14.5 12.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16667 0C14.2267 0 18.3333 4.10667 18.3333 9.16667C18.3333 9.48781 18.3168 9.80511 18.2845 10.1178C17.8681 10.0404 17.4387 10 17 10C13.136 10 10 13.136 10 17C10 17.4387 10.0404 17.8681 10.1178 18.2845C9.80511 18.3168 9.48781 18.3333 9.16667 18.3333C4.10667 18.3333 0 14.2267 0 9.16667C0 4.10667 4.10667 0 9.16667 0ZM4.675 12.3658L5.95833 13.6492C6.14167 13.8325 6.42583 13.8325 6.60917 13.6492L9.735 10.5233C10.8533 10.9175 12.155 10.6792 13.0533 9.78083C14.0708 8.76333 14.245 7.22333 13.5942 6.0225L11.44 8.17667L10.1475 6.88417L12.3017 4.73917C11.0917 4.08833 9.56083 4.2625 8.54333 5.28C7.645 6.17833 7.40667 7.48 7.80083 8.59833L4.675 11.7242C4.50083 11.8983 4.50083 12.1917 4.675 12.3658Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiStepTestRun);
export default __webpack_public_path__ + "static/media/AIStepTestRun.2c8ebef4138dcd56f67c5323f65b0beb.svg";
export { ForwardRef as ReactComponent };